import React from 'react';
interface XmlIconProps {
  className?: string;
}
export const XmlIcon: React.FC<XmlIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.2222 0H3.77778C1.7 0 0 1.7 0 3.77778V30.2222C0 32.3 1.7 34 3.77778 34H30.2222C32.3 34 34 32.3 34 30.2222V3.77778C34 1.7 32.3 0 30.2222 0ZM12.2778 16.0556C12.2778 17.5667 10.9556 18.8889 9.44444 18.8889H7.55556V22.6667H4.72222V11.3333H9.44444C10.9556 11.3333 12.2778 12.6556 12.2778 14.1667V16.0556ZM21.7222 19.8333C21.7222 21.3444 20.4 22.6667 18.8889 22.6667H14.1667V11.3333H18.8889C20.4 11.3333 21.7222 12.6556 21.7222 14.1667V19.8333ZM29.2778 14.1667H26.4444V16.0556H29.2778V18.8889H26.4444V22.6667H23.6111V11.3333H29.2778V14.1667ZM17 14.1667H18.8889V19.8333H17V14.1667ZM7.55556 14.1667H9.44444V16.0556H7.55556V14.1667Z"
                fill="#2B3467"
            />
            <rect x="4" y="9" width="26" height="16" rx="4" fill="#2B3467" />
            <path
                d="M6.46875 23H3.64062V18.875L5.19531 17.5156L3.64062 16.1328V11.7969H6.48438V14.9219L7.30469 15.6406L8.11719 14.9219V11.7969H10.9688V16.1328L9.42969 17.5156L10.9844 18.875V23H8.14844V20.1172L7.30469 19.3828L6.46875 20.1172V23ZM14.7734 16.8438V23H12.2656V11.7969H16.1172L17.3516 16.8438L18.5078 11.7969H22.4375V23H19.9297V16.8438L18.4219 23H16.2969L14.7734 16.8438ZM26.5625 11.7969V20.1719H31.0469V23H23.7188V11.7969H26.5625Z"
                fill="white"
            />
        </svg>
    );
};
